import React, { useState } from 'react';
import SnackbarContext from '../contexts/snackbar-context';
import { CloseIcon } from '../components/icons';
import { IconButton, Snackbar, SvgIcon } from '@mui/material';

export const SnackbarProvider: React.FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('');

  const showMessage = (message: string) => {
    setMessage(message);
    setIsOpen(true);
  };

  const handleClose = () => setIsOpen(false);

  return (
    <SnackbarContext.Provider value={{ showMessage }}>
      {children}
      <Snackbar
        open={isOpen}
        autoHideDuration={60000}
        onClose={handleClose}
        message={message}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        action={
          <IconButton onClick={handleClose} size="small" color="inherit">
            <SvgIcon component={CloseIcon} viewBox="0 0 24 24" fontSize="small" />
          </IconButton>
        }
      />
    </SnackbarContext.Provider>
  );
};
